import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M53 22h10v29H53V22zm-13 0h10v29H40V22zm-26 0h10v29H14V22zm13 0h10v29H27V22zM1 22h10v29H1V22z",
      fill: "#55acba"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4 25h4v23H4V25zm52 0h4v23h-4V25zm-13 0h4v23h-4V25zm-13 0h4v23h-4V25zm-13 0h4v23h-4V25z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#55acba"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22 9v9.42L31.443 26 42 18.876V9H22z",
      fill: "#55acba"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24 12v4.99L31.226 24 40 16.99V12H24z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#55acba"
    }, null, -1)
  ])))
}
export default { render: render }